import React from "react";
import { Icon } from 'react-icons-kit';
import RenderIcon from "components/CustomWidgets/RenderIcon";
import { shoppingCart as faShoppingCart } from 'react-icons-kit/fa/shoppingCart';
import { eye as faEye } from 'react-icons-kit/fa/eye';

// Product data with unique items for each category
const products = [
  // Resume Templates
  {
    id: 1,
    title: "Modern Resume Template Kit with Editable templates, Cover Letters, Resume Tips and ATS‑friendly",
    description: "Your job hunt just got easier. With 10 cover letters, multi‑format resume templates, and expert tips, this kit helps you build a professional resume in minutes. ATS‑ready and easy to edit, it’s the perfect toolkit for landing interviews faster.",
    category: "Resume Templates",
    purchaseLink: "https://www.etsy.com/listing/4413357649/modern-resume-template-kit-with-editable",
    demoLink: "https://www.etsy.com/listing/4413357649/modern-resume-template-kit-with-editable",
    icon: <RenderIcon name="https://github.com/learninjavagithub/assets/raw/master/shop/resumekit-thumbnail.png" size="3" type="url" className="text-4xl mb-4 text-blue-600" />
  },

  // Portfolio Templates
  {
    id: 2,
    title: "Modern Developer Portfolio Template – Responsive Digital Download, CV/Resume Design (Modern Theme)",
    description: "Elevate your professional presence with the Modern Developer Portfolio, a clean and responsive template designed to showcase your skills, projects, and achievements. Whether you're a software engineer, web developer, or tech freelancer, this portfolio helps you stand out with a polished design and easy customization.",
    category: "Portfolio Templates",
    purchaseLink: "https://www.etsy.com/listing/4420595100/modern-developer-portfolio-template",
    demoLink: "https://modern-portfolio-khaki-kappa.vercel.app/",
    icon: <RenderIcon name="https://github.com/learninjavagithub/assets/raw/master/shop/modern-thumbnail.png" size="3" type="url" className="text-4xl mb-4 text-blue-600" />
  },
  {
    id: 3,
    title: "Resume Style Developer Portfolio Template – Responsive Digital Download, CV/Resume Design (Resume Style Theme)",
    description: "Elevate your professional presence with the Modern Developer Portfolio, a clean and responsive template designed to showcase your skills, projects, and achievements. Whether you're a software engineer, web developer, or tech freelancer, this portfolio helps you stand out with a polished design and easy customization.",
    category: "Portfolio Templates",
    purchaseLink: "https://www.etsy.com/listing/4422181088/resume-style-developer-portfolio",
    demoLink: "https://resume-portfolio-topaz-phi.vercel.app/",
    icon: <RenderIcon name="https://github.com/learninjavagithub/assets/raw/master/shop/resume-thumbnail.png" size="3" type="url" className="text-4xl mb-4 text-blue-600" />
  },
  {
    id: 4,
    title: "Elegant Developer Portfolio Template – Responsive Digital Download, CV/Resume Design (Elegant Theme)",
    description: "Elevate your professional presence with the Modern Developer Portfolio, a clean and responsive template designed to showcase your skills, projects, and achievements. Whether you're a software engineer, web developer, or tech freelancer, this portfolio helps you stand out with a polished design and easy customization.",
    category: "Portfolio Templates",
    purchaseLink: "https://www.etsy.com/listing/4422173845/elegant-developer-portfolio-template",
    demoLink: "https://elegant-portfolio-rie4.vercel.app/",
    icon: <RenderIcon name="https://github.com/learninjavagithub/assets/raw/master/shop/elegant-thumbnail.png" size="3" type="url" className="text-4xl mb-4 text-blue-600" />
  },
  {
    id: 5,
    title: "Creative Developer Portfolio Template – Responsive Digital Download, CV/Resume Design (Creative Theme)",
    description: "Elevate your professional presence with the Modern Developer Portfolio, a clean and responsive template designed to showcase your skills, projects, and achievements. Whether you're a software engineer, web developer, or tech freelancer, this portfolio helps you stand out with a polished design and easy customization.",
    category: "Portfolio Templates",
    purchaseLink: "https://www.etsy.com/listing/4421478862/creative-developer-portfolio-template",
    demoLink: "https://creative-portfolio-five-tau.vercel.app/",
    icon: <RenderIcon name="https://github.com/learninjavagithub/assets/raw/master/shop/creative-thumbnail.jpeg" size="3" type="url" className="text-4xl mb-4 text-blue-600" />
  },
  {
    id: 6,
    title: "Tech Developer Portfolio Template – Responsive Digital Download, CV/Resume Design (Tech Theme)",
    description: "Elevate your professional presence with the Modern Developer Portfolio, a clean and responsive template designed to showcase your skills, projects, and achievements. Whether you're a software engineer, web developer, or tech freelancer, this portfolio helps you stand out with a polished design and easy customization.",
    category: "Portfolio Templates",
    purchaseLink: "https://www.etsy.com/listing/4420607519/tech-developer-portfolio-template",
    demoLink: "https://tech-portfolio-tau.vercel.app/",
    icon: <RenderIcon name="https://github.com/learninjavagithub/assets/raw/master/shop/technical-thumbnail.png" size="3" type="url" className="text-4xl mb-4 text-blue-600" />
  },

  // Software Tools
  {
    id: 7,
    title: "CodeCrack AI - Java Coding Interview Prep Tool",
    description: "A collection of reusable React components with TypeScript support, fully customizable and responsive.",
    category: "Software Tools",
    purchaseLink: "https://www.etsy.com/listing/4441471962/java-interview-questions-coding-test",
    demoLink: "https://codecrack-ai-preview.vercel.app/",
    icon: <RenderIcon name="https://github.com/learninjavagithub/assets/raw/master/codecrack-ai-cover-page.png" size="3" type="url" className="text-4xl mb-4 text-blue-600" />
  }
];

class Products extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedCategory: 'All Products'
    };
  }

  handleCategorySelect = (category) => {
    this.setState({ selectedCategory: category });
  };

  render() {
    const { selectedCategory } = this.state;
    const categories = ['All Products', ...new Set(products.map(product => product.category))];

    const filteredProducts = selectedCategory === 'All Products'
      ? products
      : products.filter(product => product.category === selectedCategory);

    return (
      <React.Fragment>
        <div className="header-bar"></div>
        <div
          className="container-fluid"
          style={{
            minHeight: "650px",
            position: "relative"
          }}
        >
          <div className="row">
            <div className="col-md-12">
              <div className="text-center">
                <h1 style={{ color: "#ef6c00" }}>Digital Products</h1>
                <h2>High-quality resources to boost your development career</h2>
              </div>

              {/* Category Filter */}
              <div className="text-center" style={{ margin: '20px 0' }}>
                <div className="btn-group" role="group">
                  {categories.map((category) => (
                    <button
                      key={category}
                      type="button"
                      className={`btn ${selectedCategory === category ? 'btn-primary' : 'btn-default'}`}
                      onClick={() => this.handleCategorySelect(category)}
                      style={{
                        textTransform: 'capitalize',
                        margin: '0 4px',
                        padding: '6px 16px',
                        borderRadius: '4px',
                        border: `1px solid ${selectedCategory === category ? 'transparent' : '#ef6c00'}`,
                        backgroundColor: selectedCategory === category ? '#ef6c00' : 'transparent',
                        color: selectedCategory === category ? 'white' : '#ef6c00',
                        transition: 'all 0.3s ease',
                        fontWeight: 500,
                        boxShadow: 'none',
                        outline: 'none',
                        cursor: 'pointer',
                        ':hover': {
                          backgroundColor: selectedCategory === category ? '#d45d00' : 'rgba(239, 108, 0, 0.1)',
                          borderColor: selectedCategory === category ? 'transparent' : '#ef6c00'
                        }
                      }}
                    >
                      {category}
                    </button>
                  ))}
                </div>
              </div>

              {/* Products Grid */}
              <div className="row">
                {filteredProducts.length > 0 ? (
                  filteredProducts.map((product) => (
                    <div key={product.id} className="col-md-4 col-sm-6">
                      <div className="panel panel-default" style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                        <div className="panel-heading" style={{ textAlign: 'center', padding: '15px' }}>
                          <h3 className="panel-title">{product.title}</h3>
                        </div>
                        <div className="panel-body" style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
                          <div style={{ textAlign: 'center', marginBottom: '15px' }}>
                            {product.icon}
                          </div>
                          <p className="displayTextLight" style={{ flex: '1' }}>{product.description}</p>
                          <div style={{ marginTop: 'auto' }}>
                            <div className="btn-group" style={{ width: '100%' }}>
                              <a
                                href={product.demoLink}
                                className="btn btn-default btn-sm"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  flex: 1,
                                  display: 'inline-flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  padding: '6px 12px',
                                  margin: '0 2px',
                                  textDecoration: 'none',
                                  color: '#ef6c00',
                                  border: '1px solid #ef6c00',
                                  borderRadius: '4px',
                                  transition: 'all 0.3s ease'
                                }}
                              >
                                <Icon icon={faEye} style={{ marginRight: '5px' }} /> Live Demo
                              </a>
                              <a
                                href={product.purchaseLink}
                                className="btn btn-primary btn-sm"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  flex: 1,
                                  display: 'inline-flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  padding: '6px 12px',
                                  margin: '0 2px',
                                  backgroundColor: '#ef6c00',
                                  color: 'white',
                                  border: '1px solid #ef6c00',
                                  borderRadius: '4px',
                                  textDecoration: 'none',
                                  transition: 'all 0.3s ease'
                                }}
                                onMouseOver={(e) => {
                                  e.currentTarget.style.backgroundColor = '#d45d00';
                                  e.currentTarget.style.borderColor = '#d45d00';
                                }}
                                onMouseOut={(e) => {
                                  e.currentTarget.style.backgroundColor = '#ef6c00';
                                  e.currentTarget.style.borderColor = '#ef6c00';
                                }}
                              >
                                <Icon icon={faShoppingCart} style={{ marginRight: '5px' }} /> Buy Now
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="col-md-12 text-center">
                    <div className="alert alert-info">
                      No products found in this category.
                    </div>
                  </div>
                )}
              </div>

              {/* Call to Action */}
              <div className="row" style={{ marginTop: '40px' }}>
                <div className="col-md-12">
                  <div className="panel panel-default">
                    <div className="panel-body text-center">
                      <h3>Looking for something else?</h3>
                      <p className="lead">
                        We're constantly adding new products. Visit our store, <a href="https://www.etsy.com/shop/TechBitesStudio?ref=dashboard-header" target="_blank" rel="noopener noreferrer">TechBites Studio</a> for more products and exclusive offers.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Products;